import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class ExperimentsClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    return appApiUrl(`experiments/`, {projectId, workspaceId});
  }

  processResponse(response) {
    return response.results;
  }
}

export const experimentsClient = new ExperimentsClient();
